<template>
  <div class="row">
    <div class="col-lg-12 col-xs-12">
      <div class="p-2">
        <h2 class="mb-3" v-if="candidates.length > 1">
          Os Candidato(a)s receberão esse feedback
        </h2>
        <h2 class="mb-3" v-if="candidates.length == 1">
          O Candidato(a) recebera esse feedback
        </h2>
        <hr />
        <div class="row">
          <div class="col-lg-6 col-xs-12">
            <div
              v-for="(candidate, index) in candidatesCurrent"
              :key="candidate.id"
            >
              <div class="candidate_list">
                <div
                  class="row color-primary p-3"
                  :class="{
                    candidate_selected: feedback_candidates.includes(
                      candidate.candidate_id
                    ),
                  }"
                >
                  <div class="col-lg-4 col-xs-12">
                    <div
                      v-if="candidate.image == ''"
                      class="avatar_thumb bg-black"
                    ></div>
                    <img
                      v-if="candidate.image != ''"
                      :src="candidate.image"
                      class="shadow_bar avatar_thumb"
                    />
                  </div>
                  <div class="col-lg-8 col-xs-12">
                    <div @click="deleteCandidate(index)" class="close-alt">
                      <font-awesome-icon
                        :icon="['fas', 'trash-alt']"
                      ></font-awesome-icon>
                    </div>
                    <span class="f25">
                      <b>{{ candidate.name.split(" ")[0] }}</b>
                    </span>
                    <br />
                    <a
                      class="f12 color-primary"
                      :href="`mailto:${candidate.email}`"
                      >{{ candidate.email }}</a
                    >
                    <p
                      class="f12 color-black"
                      v-show="
                        feedback_candidates.includes(candidate.candidate_id)
                      "
                    >
                      FEEDBACK JÁ ENVIADO,
                      <br />SERÁ ENVIADO NOVAMENTE
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xs-12">
            <h2>{{ feedback.title }}</h2>
            <span v-html="feedback.description"></span>
            <div v-if="feedback.gallery_item">
              <video
                v-show="feedback.use_video"
                width="100%"
                controls
                controlslist="nodownload"
              >
                <source :src="feedback.gallery_item.video" />
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 p-0 m-0 center">
      <button
        @click="sendFeedback"
        type="button"
        class="btn radius-0 full btn btn-outline-success"
      >
        OK ENVIAR FEEDBACK
      </button>
    </div>
    <div class="col-lg-6 p-0 m-0 center">
      <button
        @click="$emit('close')"
        type="button"
        class="radius-0 full btn btn-outline-danger"
      >
        CANCELAR ENVIO
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["candidates", "feedback", "feedback_selective_process"],
  mounted() {
    this.candidatesCurrent = this.candidates;
    axios
      .get(
        `/recruiters/feedback_candidates/${this.feedback_selective_process.selective_process_id}`
      )
      .then((response) => {
        this.feedback_candidates = response.data.candidates;
      });
  },
  data: () => ({
    candidatesCurrent: [],
    feedback_candidates: [],
  }),
  methods: {
    deleteCandidate(index) {
      let conf = confirm(
        "Tem certeza que deseja tirar esse Candidato(a) da lista de Feedback?"
      );
      if (!conf) return;
      this.candidatesCurrent.splice(index, 1);
    },
    sendFeedback() {
      if (this.candidatesCurrent.length == 0) {
        this.$toast.error("Não existe Candidato(a)s para serem notificados.");
        return;
      }
      axios
        .post(`/recruiters/feedback_candidates`, {
          feedbacks_candidates: {
            candidates: this.candidatesCurrent,
          },
          feedback: {
            id: this.feedback.id,
            selective_process_id: this.feedback_selective_process
              .selective_process_id,
          },
        })
        .then((response) => {
          this.$toast.success(
            "Status atualizado e feedback salvos com sucesso."
          );
          this.$emit("close");
        });
    },
  },
};
</script>

